import React from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import { Flex } from "antd";
import Image from "@components/item/Image";

const ContentContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.8rem",
  lineHeight: "2rem",
  fontSize: "1.4rem",

  ".date": {
    color: theme.color.light_gray,
    lineHeight: "1.6rem",
    fontWeight: theme.fontWeight.medium,
  },
}));

const DateBox = styled.div({
  display: "flex",
  alignItems: "flex-start",
  gap: "0.5rem",
});

const Ball = styled.div(({ theme }) => ({
  width: "7px",
  height: "7px",
  borderRadius: "50%",
  backgroundColor: theme.color.mint,
}));

type Props = {
  date: string;
  isRead: boolean;
  content: string;
  redirectUrl: string;
  thumbnail_url: string | null;
  onClick: () => void;
};
const ActivityAlarmCard = ({
  date,
  isRead,
  content,
  redirectUrl,
  thumbnail_url,
  onClick,
}: Props) => {
  const navigate = useNavigate();

  const handleClick = async () => {
    onClick(); // 알람 읽음 처리
    navigate(redirectUrl);
  };

  return (
    <Flex
      gap="2rem"
      align="flex-start"
      style={{
        padding: "1.6rem 0",
      }}>
      <Image src={thumbnail_url === null ? "" : thumbnail_url} size="4rem" />
      <ContentContainer onClick={handleClick}>
        <DateBox className="date">
          <span>{date}</span>
          {!isRead && <Ball />}
        </DateBox>
        <p>{content}</p>
      </ContentContainer>
    </Flex>
  );
};

export default ActivityAlarmCard;
